import React, { useState, useEffect } from 'react';
import LanguageSwitcher from '../../LanguageSwitcher';
import { useTranslation } from '../../../i18n/LanguageContext';

const LandingNavbar = ({ onLoginClick, onRegisterClick }) => {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const whatsappUrl = 'https://wa.me/916263618884?text=Hi%2C%20I%20want%20a%20demo%20of%20SpellStudy%20for%20my%20school.';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMobileOpen(false);
  };

  const handleLogin = () => {
    setMobileOpen(false);
    onLoginClick();
  };

  return (
    <nav className={`lp-navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="lp-container lp-navbar-inner">
        <a href="/" className="lp-navbar-logo">
          <i className="fa-solid fa-graduation-cap" />
          SpellStudy
        </a>

        <div className="lp-navbar-links">
          <a href="#pilot" onClick={(e) => { e.preventDefault(); scrollTo('pilot'); }}>{t('landing.nav.pilot')}</a>
          <a href="#role-value" onClick={(e) => { e.preventDefault(); scrollTo('role-value'); }}>{t('landing.nav.roles')}</a>
          <a href="#showcase" onClick={(e) => { e.preventDefault(); scrollTo('showcase'); }}>{t('landing.nav.product')}</a>
          <a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollTo('how-it-works'); }}>{t('landing.nav.howItWorks')}</a>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>{t('landing.nav.contact')}</a>
        </div>

        <div className="lp-navbar-actions">
          <LanguageSwitcher compact className="lp-language-switcher" />
          <button className="lp-navbar-login" onClick={handleLogin}>{t('landing.nav.login')}</button>
          <button className="lp-btn lp-btn-primary lp-navbar-cta" onClick={() => scrollTo('contact')}>
            {t('landing.nav.bookDemo')}
          </button>
          <a className="lp-navbar-whatsapp" href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label={t('landing.nav.whatsAppDemo')}>
            <i className="fa-brands fa-whatsapp" />
          </a>
        </div>

        <button className="lp-hamburger" onClick={() => setMobileOpen((open) => !open)} aria-label={t('landing.nav.openNavigation')}>
          <i className={`fa-solid ${mobileOpen ? 'fa-xmark' : 'fa-bars'}`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="lp-mobile-menu">
          <LanguageSwitcher />
          <a href="#pilot" onClick={(e) => { e.preventDefault(); scrollTo('pilot'); }}>{t('landing.nav.oneClassPilot')}</a>
          <a href="#role-value" onClick={(e) => { e.preventDefault(); scrollTo('role-value'); }}>{t('landing.nav.roleBenefits')}</a>
          <a href="#showcase" onClick={(e) => { e.preventDefault(); scrollTo('showcase'); }}>{t('landing.nav.productScreenshots')}</a>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>{t('landing.nav.bookDemo')}</a>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" onClick={() => setMobileOpen(false)}>
            <i className="fa-brands fa-whatsapp" />
            {t('landing.nav.whatsAppDemo')}
          </a>
          <button type="button" onClick={handleLogin}>{t('landing.nav.login')}</button>
        </div>
      )}
    </nav>
  );
};

export default LandingNavbar;
